import { Component, Injector, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SttComponent, BasePage, JkTableService, entityState, quillEditorOptions, jkLib } from 'jk-service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Mtrwd, Mtrwl } from '../_entity_mtr';
import { JkSingleTableComponent } from 'jk-advcom';
import { ContentChange, QuillModule } from 'ngx-quill';
import { MtrwdService, MtrwlService } from '../_service_mtr';
import { Mtrki03ModalComponent } from './mtrki03-modal.component';
import { MtrwlEditComponent } from '../_edit_mtr';

@Component({
  selector: 'app-mtrki03',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SttComponent,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatCheckboxModule
  ],
  templateUrl: './mtrki03.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./mtrki03.component.css']
})
export class Mtrki03Component extends JkSingleTableComponent implements OnInit {
  override _programId = 'mtrki04'; //###
  constructor() {
    super();
    this.srv = new MtrwdService();
    this.isCheckPower = false; // ###
    //this.qbeConfig.addField = 'WD002,WD004,WD021'; //###
    //this.qbeConfig.addWhere = ' AND (WD015 = ' + jkLib.quotedStr(this.srv.wd015)+') '; //###
    this.gridInitOpt = { pageKind: this.pageKind, programId: this.programId, sortField: 'WD002', sort: 'desc', defaultSort: null };
    this.tableDisplayedColumns = ['WD001'];
    this.tableSrv = new JkTableService(); // ###

    this.constructorInit(); // ###
  }
  displayedColumns: string[] = ['WL008', 'WL005', 'WL003', 'WL007', 'WL004', 'WL002', 'WL001'];
  dataSource: Mtrwl[] = [];
  originalDataSource: Mtrwl[] = []; // Keep original data for filtering
  wd003Text: string = '';
  transcribedText: string = '';
  isSttRecording: boolean = false;
  hideSttInput: boolean = true;
  searchTerm: string = '';
  sortOption: string = 'dateDesc'; // Default sort by date descending

  override ngOnInit() {
    super.ngOnInit();
    this.loadData();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###
    this.title = '時間線待辦事項';
    this.srv.getTodo('');
  }

  override getLookup() {
    super.getLookup();

  }
  override async titleOptionsClick(e: string) {
    //super.titleOptionsClick(e);
    if (e === 'add') {
      this.doInsertModi();

    }
  }
  async doInsertModi() {
    let wd003 = await this.showInput('請輸入工作內容', 'label', '', 'textarea');
    if (wd003) {

      let item: Mtrwd = await this.srv.doInsert();
      item.WD003 = wd003;
      item.WD015 = this.srv.wd015; //this.filterOpt.wd015;
      item.WD016 = this.uid;
      //this.srv.item = item;
      this.doUIPost(item);
    }
  }

  override async showEdit(state: entityState) {
    super.showEdit(state);
    if (state === entityState.dsInsert) {
      await this.srv.doInsert();
    };
    if (state === entityState.dsEdit) {
      this.srv.doEdit(this.srv.item); // ###
    };

    this.dialog.open(MtrwlEditComponent, this.initConfig(this))
      .afterClosed().subscribe((result) => {
        if (result) {
        }
      });

  }
  override async doUIDelete(itemData: Mtrwl): Promise<boolean> {
    let bool = await super.doUIDelete(itemData);
    return bool;
  }

  quillEditorReady($event: ContentChange) {
    this.wd003Text = $event.text;
  }
  quillEditorOptions = quillEditorOptions;

  text2html(value: string): string {
    let str = jkLib.swapStr(value, '\n', '<br>');
    let s = `<h4>${str}</h4>`;
    //let s = `${str}`;
    return s;
  }
  override async doEditAndSave($event: any): Promise<boolean> {
    if (this.wd003Text === '') {
      this.wd003Text = $event.WL004;
    }
    this.wd003Text = await this.showInput('內容', '確認要存檔?', this.wd003Text, 'textarea');
    let bool = false;
    if (this.wd003Text) {
      $event.WD003 = this.wd003Text;
      bool = await super.doEditAndSave($event);
    };
    return bool;
  }


  loadData(): void {
    this.srv.loadData().then((data: any) => {
      this.originalDataSource = data as Mtrwl[];
      this.dataSource = [...this.originalDataSource];
      this.applySortAndFilter();
    }).catch((err: any) => {
      console.error('Error loading data:', err);
    });
  }

  onSttTranscribed(text: string): void {
    this.transcribedText = text;
  }

  toggleSttRecording(): void {
    this.isSttRecording = !this.isSttRecording;
  }

  applySttToContent(): void {
    console.log('Applying STT text to content:', this.transcribedText);
  }

  onSearch(searchTerm: string): void {
    this.searchTerm = searchTerm.toLowerCase();
    this.applySortAndFilter();
  }

  onSortChange(): void {
    this.applySortAndFilter();
  }

  private applySortAndFilter(): void {
    // Start with original data
    let filteredData = [...this.originalDataSource];

    // Apply search filter
    if (this.searchTerm) {
      filteredData = filteredData.filter(record =>
        (record.WL007 && record.WL007.toLowerCase().includes(this.searchTerm)) ||
        (record.WL004 && record.WL004.toLowerCase().includes(this.searchTerm))
      );
    }

    // Apply sorting
    if (this.sortOption === 'dateDesc') {
      filteredData.sort((a, b) => {
        // Sort by WL005 (date) descending
        const dateA = a.WL005 ? new Date(a.WL005) : new Date(0);
        const dateB = b.WL005 ? new Date(b.WL005) : new Date(0);
        return dateB.getTime() - dateA.getTime();
      });
    } else if (this.sortOption === 'sortAsc') {
      filteredData.sort((a, b) => {
        // Sort by WL003 (sort order) ascending
        return (a.WL003 || 0) - (b.WL003 || 0);
      });
    }

    this.dataSource = filteredData;
  }

  onNewRecord(): void {
    // TODO: Implement new record functionality (will be covered in modal form task)
    console.log('New record clicked');
  }

  onStarToggle(record: Mtrwl): void {
    // Toggle star (WL008) between 'Y' and 'N'
    record.WL008 = record.WL008 === 'Y' ? 'N' : 'Y';
    // TODO: Save changes to backend
    console.log('Star toggled for record:', record.WL001, record.WL008);
  }

  onEditRecord(record: Mtrwl): void {
    // TODO: Implement edit record functionality (will be covered in modal form task)
    console.log('Edit record clicked:', record.WL001);
  }
}
